import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxErrorsModule } from '@ultimate/ngxerrors';
import { ComponentModule } from '../../components/component.module';
import { ChangepasswordComponent } from './changepassword.component';
import { UserService } from '../../core/service/user.service';

@NgModule({
  imports: [FormsModule, ReactiveFormsModule, NgxErrorsModule, CommonModule, ComponentModule
  ],
  declarations: [

    ChangepasswordComponent,
  ],

  exports:[ChangepasswordComponent],
  providers:[UserService]
})
export class ChangepasswordModule { }



// WEBPACK FOOTER //
// ./src/app/login/changepassword/changepassword.module.ts